export const AREA_CHART_HEIGHT = 100
export const AREA_CHART_MARGIN = { top: 5, right: 5, bottom: 5, left: 5 }
export const AREA_CHART_STYLE = { cursor: 'pointer' }

// Stacked bar chart constants
export const STACKED_BAR_CHART_MARGIN = { top: 1, right: 0, bottom: 0, left: 0 }
export const STACKED_BAR_CHART_HEIGHT = 400
export const STACKED_BAR_LABELS_WIDTH = 50
